import type { CollectionItem, CollectionItem_ListItem, CollectionItem_ListItemWithMarketplaceItem, CollectionItemWithMarketplaceItem } from "@/services/collection/item/collectionItemTypes";

export function assertHasMarketplaceItem(item: CollectionItem | CollectionItem_ListItem): asserts item is CollectionItemWithMarketplaceItem | CollectionItem_ListItemWithMarketplaceItem {
  if (item.marketPlaceItem === null) {
    throw new Error("Item has no marketplace item");
  }
}
